import type { ShoppingListItem, ShoppingModeDepartment } from '../types';

export function sortForShoppingMode(items: ShoppingListItem[]): ShoppingListItem[] {
  return [...items].sort((a, b) => {
    if (a.checked !== b.checked) return a.checked ? 1 : -1;
    if (a.checked && b.checked) {
      return b.updatedAt.localeCompare(a.updatedAt);
    }
    if (a.missing !== b.missing) return a.missing ? -1 : 1;
    if (a.position !== b.position) return a.position - b.position;
    return a.createdAt.localeCompare(b.createdAt);
  });
}

export function groupItemsByDepartment(
  items: ShoppingListItem[],
  departments: ShoppingModeDepartment[],
): Array<{ department: ShoppingModeDepartment | null; items: ShoppingListItem[] }> {
  const groups = new Map<string | null, ShoppingListItem[]>();

  for (const item of items) {
    const key = item.departmentId ?? null;
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key)!.push(item);
  }

  const result: Array<{ department: ShoppingModeDepartment | null; items: ShoppingListItem[] }> = [];

  for (const dept of departments) {
    const raw = groups.get(dept.id);
    if (raw && raw.length > 0) {
      result.push({ department: dept, items: sortForShoppingMode(raw) });
    }
  }

  const unassigned = groups.get(null);
  if (unassigned && unassigned.length > 0) {
    result.push({ department: null, items: sortForShoppingMode(unassigned) });
  }

  return result;
}
